import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import ActionButton from '@repo/ui/action-button'
import { DeleteIcon, MessageIcon } from '@repo/ui/icons'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'
import React from 'react'

type Props = {
  comment: string
  onClick?: () => void
  onDelete?: () => void
}

const SingleComment: React.FC<Props> = ({ comment, onClick, onDelete }) => {
  return (
    <InnerBox
      className={cn(
        'flex items-center flex-row border-grey-stroke py-1.5 px-2 my-2 w-full min-w-[200px]',
        {
          'justify-between': !!onDelete
        }
      )}
    >
      <div onClick={onClick} className="flex items-center gap-3 rounded  ">
        <div className="flex-shrink-0">
          <MessageIcon color={tailwindColors.primary.DEFAULT} />
        </div>

        <Typography
          className="break-words whitespace-pre-wrap min-w-0 flex-1 leading-5"
          variant="label-medium"
          color={tailwindColors.primary.DEFAULT}
        >
          {comment}
        </Typography>
      </div>

      {onDelete && (
        <ActionButton
          size="x-small"
          variant="danger"
          icon={DeleteIcon}
          onClick={onDelete}
          className="ml-2"
        />
      )}
    </InnerBox>
  )
}

export default SingleComment
